define([
    'react',
    'lodash',
    'lists/list',
    'lists/list-item',
    '../assessment-card',
    'dialogs/dialog',
    'buttons/button'
], function (React, _, List, ListItem, AssessmentCard, Dialog, Button) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': this.getStyles().listExample }, React.createElement(Button, {
            'type': 'default',
            'onClick': this.handleButtonClick
        }, 'Open dialog'), React.createElement(Dialog, {
            'active': this.state.isDialogOpen,
            'onRequestClose': this.handleCloseDialog,
            'actions': this.dialogActions(),
            'header': 'Select assessment type',
            'autoFocus': false,
            'hasOuterScrollX': true,
            'hasInnerScrollX': false,
            'minWidth': 750
        }, React.createElement('div', { 'className': this.getStyles().dialog }, React.createElement(List, {
            'values': this.state.activeDialogCard,
            'onChange': this.handleDialogCardChange,
            'className': this.getStyles().assessmentList
        }, React.createElement(ListItem, { 'value': 'first' }, React.createElement(AssessmentCard, {
            'icon': 'icon-file-check',
            'text': 'formative',
            'className': this.getStyles().assessmentCard
        })), React.createElement(ListItem, { 'value': 'second' }, React.createElement(AssessmentCard, {
            'icon': 'icon-file-locked',
            'text': 'summative',
            'className': this.getStyles().assessmentCard
        })), React.createElement(ListItem, { 'value': 'third' }, React.createElement(AssessmentCard, {
            'icon': 'icon-file-presentation',
            'text': 'mixed',
            'className': this.getStyles().assessmentCard
        }))), React.createElement('div', { 'className': this.getStyles().description }, React.createElement('p', {}, 'The main purpose of formative assessments is to let candidates practice and therefore often include feedback.'), React.createElement('p', {}, 'Only questions tagged as Formative will be used for this assessment.')))));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/lists/example/dialog-example/dialog-example.rt
 ** module id = 175
 ** module chunks = 0
 **/